// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"658bf51e","47":"d717d7d1","74":"5a0d0df3","309":"299a234e","352":"974103cf","453":"a5e28f77","455":"71b60dc2","826":"1b0dfbb7","855":"962d8344","892":"866f6787","951":"5d0eca46","971":"23f8be04"}[chunkId] + ".chunk.js";
};